export default __webpack_public_path__ + "06c0b0012376820b1a8137f4f1c91f9c.png";